import { defineComponent as _defineComponent } from 'vue'
import VsButton from '@/components/vision/VsButton.vue'
import VsText from '@/components/vision/VsText.vue'
import AutoCompleteShell from '@/components/vision/next/inputs/AutoCompleteShell.vue'
import PickerListVirtualized from '@/components/vision/next/picker-list/PickerListVirtualized.vue'
import PickerListItem from '@/components/vision/next/picker-list/PickerListItem.vue'
import ChipFilter from '@/components/vision/next/ChipFilter.vue'
import { useHeadlessLocationPicker } from '@/components/locations/HeadlessLocationPicker'
import { computed, nextTick, ref, toRef, onMounted } from 'vue'
import { HeadlessAutoCompleteValueType } from '@/components/vision/next/inputs/useAutoComplete'
import { useQueryClient } from '@tanstack/vue-query'
import { getById } from '@/api/locations'
import moment from 'moment'
import { isEqual } from 'lodash'


export default /*#__PURE__*/_defineComponent({
  __name: 'JobsFilterLocationsAside',
  props: {
    selectedItems: { default: () => [] }
  },
  emits: ["leave-panel", "save-filters"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'leave-panel'): void
  (event: 'save-filters', locationIds: number[]): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { selectedItems: number[] }





const internalSelection = ref<number[]>(props.selectedItems)

const autocomplete = ref<InstanceType<typeof AutoCompleteShell>>()
const virtualizedList = ref<InstanceType<typeof PickerListVirtualized>>()

const noLocationOption = {
  id: null,
  title: 'Let the dispatcher decide',
  subTitle: 'Show jobs with no specified pickup location',
  selectable: true,
}

const getScrollPosition = () => {
  return virtualizedList?.value?.getScrollPosition()
}

const scrollToPosition = (pos: number) => {
  return virtualizedList?.value?.scrollToPosition(pos)
}

const onNavigate = () => {
  autocomplete.value?.input?.focus()
}

const onValueChanged = (items: HeadlessAutoCompleteValueType[]) => {
  autocomplete.value?.input?.focus()
  internalSelection.value = items.map((i) => i.id as number)
}

const isSelected = (item: HeadlessAutoCompleteValueType) => {
  return internalSelection.value.includes(item.id as number)
}

const client = useQueryClient()

const valueResolver = async (id) => {
  if (id === null) {
    return noLocationOption
  }

  const location = await client.fetchQuery({
    queryKey: ['locations', id],
    queryFn: ({ signal }) => getById(id, signal),
    staleTime: moment.duration(10, 'minutes').asMilliseconds(),
  })

  return { id: location.id, title: location.location }
}

const {
  items,
  isFetching,
  locationType,
  locationTypes,
  selectLocationType,
  parentName,
  updateSearch,
  continueFetching,
  navigateIntoItem,
  navigateBack,
  selectItem,
  noResultsMessage,
  clear,
  rawSearchText,
} = useHeadlessLocationPicker({
  getScrollPosition,
  scrollToPosition,
  onNavigate,
  onValueChanged,
  multiple: true,
  value: internalSelection,
  valueResolver,
})

const isDirty = computed(
  () => !isEqual(internalSelection.value, props.selectedItems)
)

const showNoLocationOption = computed(() => {
  return !locationType.value?.id && !parentName.value && !rawSearchText.value
})

const reset = () => {
  internalSelection.value = []
  clear()
  handleLeavePanel()
}

const save = () => {
  emit('save-filters', internalSelection.value)
}

const handleLeavePanel = () => {
  emit('leave-panel')
}

onMounted(() => {
  autocomplete.value?.input?.focus()
})

return { __sfc: true,props, emit, internalSelection, autocomplete, virtualizedList, noLocationOption, getScrollPosition, scrollToPosition, onNavigate, onValueChanged, isSelected, client, valueResolver, items, isFetching, locationType, locationTypes, selectLocationType, parentName, updateSearch, continueFetching, navigateIntoItem, navigateBack, selectItem, noResultsMessage, clear, rawSearchText, isDirty, showNoLocationOption, reset, save, handleLeavePanel, VsButton, VsText, AutoCompleteShell, PickerListVirtualized, PickerListItem, ChipFilter }
}

})